﻿import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import YourId from "./YourId.svelte";
import TypeOfClaim from "./TypeOfClaim.svelte";
import ClaimForYourself from "./ClaimForYourself.svelte";
import ClaimForYourSpouse from "./ClaimForYourSpouse.svelte";
import ClaimForYourParent from "./ClaimForYourParent.svelte";
import BankAccountDetails from "./BankAccountDetails.svelte";
import AdditionalInformation from "./AdditionalInformation.svelte";

const confirmationPages = [
	{
		component: PersonalDetails,
		routeId: "/SettlementRegistration/PersonalDetails",
		confirmationHeading: "Your details"
	},
	{
		component: YourId,
		routeId: "/SettlementRegistration/YourID",
		confirmationHeading: "Your ID"
	},
	{
		component: TypeOfClaim,
		routeId: "/SettlementRegistration/TypeOfClaim",
		confirmationHeading: "Type Of Claim"
	},
	{
		component: ClaimForYourself,
		routeId: "/SettlementRegistration/ClaimForYourself",
		confirmationHeading: "Claim for Yourself",
		hidePage: (model) => model.registrationType != "Individual (Myself)"
	},
	{
		component: ClaimForYourSpouse,
		routeId: "/SettlementRegistration/ClaimForYourSpouse",
		confirmationHeading: "Claim for Your Spouse",
		hidePage: (model) => model.registrationType != "Individual (Spouse)"
	},
	{
		component: ClaimForYourParent,
		routeId: "/SettlementRegistration/ClaimForYourParent",
		confirmationHeading: "Claim for Your Parent",
		hidePage: (model) => model.registrationType != "Individual (Parent)"
	},
	{
		component: BankAccountDetails,
		routeId: "/SettlementRegistration/YourBankAccountDetails",
		confirmationHeading: "Your Bank Account Details"
	},
	{
		component: AdditionalInformation,
		routeId: "/SettlementRegistration/AdditionalInformation",
		confirmationHeading: "Additional and Authorisation Details"
	}
];

export default confirmationPages;
